export default {
	name: "campaign-management",
	data() {
		return {
			campaigns: [],
			campaignsHeadings: [
				{
					text: "Campaign",
					field: "campaignName"
				},
				{
					text: "Sites",
					field: "siteNames"
				},
				{
					text: "Is Active",
					field: "isActive"
				},
				{
					text: "Winner Drawn",
					field: "hasWinner"
				},
				{
					text: "Start Date",
					field: "startDateString"
				},
				{
					text: "Closing Date",
					field: "endDateString"
				},
				{
					text: "Date Created",
					field: "insertedOnString"
				}
			],
			sites: [],
			pagingDetails:{
				pageNumber: 1,
				pageSize: 10,
				totalPages: 1
			},
			actions: [],
			actionKeys:{
				edit: "edit",
				markAsActiveInactive: "markAsActiveInactive",
				viewSubmissions: "viewSubmissions",
				viewWinningSubmission: "viewWinningSubmission",
				drawWinner: "drawWinner",
				getLink: "getLink"
			},
			addOrUpdateCampaignModal:{
				showModal: false,
				isSaving: false,
				modalId: "addOrUpdateCampaignModal",
				heading: "Add Or Update Campaign",
				isActive: null,
				campaignToEdit: null
			},
			campaignMarkAsActiveInactiveModal:{
				showModal: false,
				isSaving: false,
				modalId: "markAsActiveInactiveCampaignModal",
				heading: "Mark Campaign As Active/Inactive",
				isActive: null,
				campaignId: null
			},
			campaignLinkModal:{
				campaignId: null,
				campaignLink: null,
				name: null,
				modalId: "campaignLinkModal"
			},
			drawWinnerModal:{
				showModal: false,
				isSaving: false,
				modalId: "drawWinnerModal",
				heading: "Draw Winner",
				campaignId: null
			},
			viewSubmissionModal: {
				showModal: false,
				modalId: "viewSubmissionModal",
				heading: "View Submission Drawn Winner",
				submission: {},
				submissionIsDrawnWinner: true
			},
			filterStateChanged: false,
			filter:{
				fromDateCreated: null,
				toDateCreated: null,
				customerSearchQuery: null,
				activeOrInactiveItems: 1,
				siteId: null,
			},
			activeIsActiveKey:{
				active: 1,
				inactive: 0
			},
			pageNumber: 1,
			pageSize: 100,
			loading: false,
			selectedHeartbeatStatusCodeId: null
		};
	},
	methods: {
		getCampaigns(){
			this.loading = true;
			let request = {
				searchTerm: this.filter.customerSearchQuery,
				pageNumber: this.pagingDetails.pageNumber,
				pageSize: this.pagingDetails.pageSize,
				// fromDateCreated: this.filter.fromDateCreated,
				// toDateCreated: this.filter.toDateCreated,
				isActive: castingUtility.toBoolean(this.filter.activeOrInactiveItems),
				siteId: this.filter.siteId === 0 ? null : this.filter.siteId 
			};
			competitionService.getAllCampaigns(request).then(
				response => {
					if(response.status === 200){
						this.campaigns = response.data.result;
						this.pagingDetails.totalPages = response.data.pagingInfo.totalPages;
						for(let i = 0; i < this.campaigns.length; i++){
							this.campaigns[i].actions = [
								{
									name: "Edit",
									key: this.actionKeys.edit,
									elementId: "btnEditCampaignAction"
								},
								{
									name: this.campaigns[i].isActive ? "Mark As Inactive" : "Mark As Active",
									key: this.actionKeys.markAsActiveInactive,
									elementId: "btnMarkAsActiveOrInactiveCampaignAction"
								},
								{
									name: "View Submissions",
									key: this.actionKeys.viewSubmissions,
									elementId: "btnViewSubmissionsAction"
								},
								{
									name: "Get Link",
									key: this.actionKeys.getLink,
									elementId: "btnGetLinkAction"
								}
							];
							if(this.campaigns[i].hasWinner){
								this.campaigns[i].actions.push({
									name: "View Winning Submission",
									key: this.actionKeys.viewWinningSubmission,
									elementId: "btnViewWinningSubmissionAction"
								});
							}
							else{
								this.campaigns[i].actions.push({
									name: "Draw Winner",
									key: this.actionKeys.drawWinner,
									elementId: "btnDrawWinnerAction"
								});
							}
						}
						this.filterStateChanged = false;
						this.campaigns = dataTableHelper.castFieldValues(this.campaigns);
						console.log("campaigns", this.campaigns);
						this.loading = false;
					}
				}
			);
		},
		getSites(){
			systemService.getSites().then(
				response => {
					this.sites = response.data.result;
					this.sites.unshift(
						{
							siteId: 0,
							siteName: "All"
						});
					this.sites = $.map(this.sites,
						function (obj) {
							obj.id = obj.id || obj.siteId;
							obj.text = obj.text || obj.siteName;
							return obj;
						});
					var self = this;
					setTimeout(function(){
						self.filter.siteId = 0;
					}, 100);
				}
			);
		},
		onActiveInactiveFilterSelected(activeOrInactiveKey){
			this.filter.activeOrInactiveItems = activeOrInactiveKey;
			this.filterStateChanged = true;
			console.log("filter", this.filter);
		},
		onSiteFilterSelect(site){
			console.log("site", site);
			if(this.filter.siteId !== site.id) {
				this.filterStateChanged = true;
				this.filter.siteId = site.id;
			}
			// if(site.id === 0){
			// 	this.filter.siteId = null;
			// }
			// else{
			// 	this.filter.siteId = site.id;
			// }
		},
		onFilterSearchClicked(){
			console.log("Search filter clicked");
			this.pagingDetails.pageNumber = 1;
			this.pagingDetails.totalPages = 1;
			this.getCampaigns();
		},
		onPagingUpdated(pagingInfo){
			console.log("pagingInfo", pagingInfo)
			this.pagingDetails.pageNumber = pagingInfo.pageNumber;
			this.getCampaigns();
		},
		addNewCampaign(){
			this.addOrUpdateCampaignModal.showModal = true;
		},
		editCampaign(campaign){
			this.addOrUpdateCampaignModal.showModal = true;
			this.addOrUpdateCampaignModal.campaignToEdit = campaign;
		},
		closeAddOrUpdateCampaignModal(){
			this.addOrUpdateCampaignModal.showModal = false;
			this.getCampaigns();
		},
		onMarkAsActiveInactiveSaveClick(markAsActive){
			this.campaignMarkAsActiveInactiveModal.isSaving = true;
			let request = {
				campaignId: this.campaignMarkAsActiveInactiveModal.campaignId,
				isActive: markAsActive
			};
			competitionService.markCampaignAsActiveOrInactive(request).then(
				response => {
					if(response.status === 200){
						this.getCampaigns();
						this.campaignMarkAsActiveInactiveModal.showModal = false;
						this.campaignMarkAsActiveInactiveModal.isActive = true;
						this.campaignMarkAsActiveInactiveModal.campaignId = null;
					}
					this.campaignMarkAsActiveInactiveModal.isSaving = false;
				}
			);
		},
		onCampaignActionClicked(actionAndData){
			console.log("actionAndData", actionAndData);
			switch(actionAndData.action){
				case this.actionKeys.edit:
					this.editCampaign(actionAndData.data);
					break;
				case this.actionKeys.markAsActiveInactive:
					this.campaignMarkAsActiveInactiveModal.showModal = true;
					this.campaignMarkAsActiveInactiveModal.campaignId = actionAndData.data.campaignId;
					this.campaignMarkAsActiveInactiveModal.isActive = castingUtility.toBoolean(actionAndData.data.isActive);
					this.campaignMarkAsActiveInactiveModal.heading = "Mark Campaign As " + (this.campaignMarkAsActiveInactiveModal.isActive ? "Inactive - " : "Active - ") + actionAndData.data.campaignName;
					break;
				case this.actionKeys.getLink:
					this.campaignLinkModal.campaignId = actionAndData.data.campaignId;
					this.campaignLinkModal.name = actionAndData.data.campaignName;
					this.generateCampaignLink();
					$("#" + this.campaignLinkModal.modalId).modal("show");
					break;
				case this.actionKeys.drawWinner:
					this.drawWinnerModal.showModal = true;
					this.drawWinnerModal.campaignId = actionAndData.data.campaignId;
					this.drawWinnerModal.heading = "Draw Winner - " + actionAndData.data.campaignName;
					break;
				case this.actionKeys.viewWinningSubmission:
					this.getWinningSubmissionByCampaign(actionAndData.data.campaignId);
					break;
				case this.actionKeys.viewSubmissions:
					this.$router.push("/competitionManagement/submissionManagement/" + actionAndData.data.campaignId);
					break;
			}
		},
		closeDrawWinnerModal(){
			this.drawWinnerModal.showModal = false;
			this.drawWinnerModal.campaignId = null;
		},
		onWinningSubmissionSelected(submission){
			this.drawWinnerModal.showModal = false;
			this.drawWinnerModal.campaignId = null;
			var self = this;
			setTimeout(() => {
				self.viewSubmissionModal.showModal = true;
				self.viewSubmissionModal.submission = submission;
			}, 500);
		},
		onViewSubmissionModalClose(){
			this.viewSubmissionModal.showModal = false;
			this.viewSubmissionModal.submissionIsDrawnWinner = true;
			this.getCampaigns();
		},
		onDrawnWinnerRejectedRedraw(){
			this.viewSubmissionModal.showModal = false;
			this.viewSubmissionModal.submissionIsDrawnWinner = true;
			var self = this;
			setTimeout(() => {
				self.drawWinnerModal.showModal = true;
				self.drawWinnerModal.campaignId = self.viewSubmissionModal.submission.campaignId;
			}, 500);
		},
		generateCampaignLink(){
			competitionService.generateCampaignLink(this.campaignLinkModal.campaignId).then(
				response => {
					if(response.status === 200){
						this.campaignLinkModal.campaignLink = response.data.link;
					}
				}
			);
		},
		getWinningSubmissionByCampaign(campaignId){
			this.loading = true;
			competitionService.getWinningSubmissionByCampaign(campaignId).then(
				response =>{
					if(response.status === 200){
						this.viewSubmissionModal.showModal = true;
						this.viewSubmissionModal.submission = response.data.result;
						this.viewSubmissionModal.submissionIsDrawnWinner = false;
					}
					this.loading = false;
				}
			);
		},
		setBreadcrumbs() {
			storeState.setPageTitleAction("Campaigns");
			breadcrumbsStoreState.setRootBreadcrumb(this.$route.path, "Campaigns");
		}
	},
	mounted: function () {
		this.setBreadcrumbs();
		this.getCampaigns();
		this.getSites();
	}
};